import { render, staticRenderFns } from "./CloseBar.vue?vue&type=template&id=c657138a&scoped=true"
import script from "./CloseBar.vue?vue&type=script&lang=js"
export * from "./CloseBar.vue?vue&type=script&lang=js"
import style0 from "./CloseBar.vue?vue&type=style&index=0&id=c657138a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c657138a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c657138a')) {
      api.createRecord('c657138a', component.options)
    } else {
      api.reload('c657138a', component.options)
    }
    module.hot.accept("./CloseBar.vue?vue&type=template&id=c657138a&scoped=true", function () {
      api.rerender('c657138a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/canvas/components/editor/CloseBar.vue"
export default component.exports